import React from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { Search, ShoppingCart, Bell, Video } from 'lucide-react';

// beRides top nav — TRANSPARENT (overlays the hero so video plays edge-to-edge).
// Links and logo are white.  Active menu item gets a burgundy underline.
const navItems = [
  { label: 'SHOP',         to: '/shop',          matchPrefixes: ['/shop']                         },
  { label: 'LOOK + LEARN', to: '/look-and-learn', matchPrefixes: ['/look-and-learn', '/build']    },
  { label: 'HIRE',         to: '/hire',          matchPrefixes: ['/hire']                         },
  { label: 'CONNECT',      to: '/connect',       matchPrefixes: ['/connect']                      },
];

const TopNav = () => {
  const { pathname } = useLocation();
  // Always fixed to the viewport top so the menu is sticky while the rest of
  // the page scrolls (client requirement).  Semi-transparent so it blends
  // nicely on the hero video and still reads cleanly on white content.
  const shellClass = 'fixed top-0 inset-x-0 z-50 bg-black/70 backdrop-blur-md border-b border-white/10';

  return (
    <nav className={shellClass} data-testid="top-nav">
      <div className="w-full px-8 md:px-12 h-16 grid grid-cols-[1fr_auto_1fr] items-center">
        {/* LEFT — menu */}
        <div className="flex items-center gap-9 font-display text-[13px] tracking-[0.2em] uppercase text-white/90">
          {navItems.map((it) => {
            const isActive = it.matchPrefixes.some((p) => pathname.startsWith(p));
            return (
              <Link
                key={it.label}
                to={it.to}
                data-testid={`nav-${it.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
                className={`relative transition py-5 ${isActive ? 'text-white' : 'hover:text-white text-white/85'}`}
              >
                {it.label}
                {isActive && (
                  <span className="absolute left-0 right-0 -bottom-px h-0.5 bg-[var(--accent)]" />
                )}
              </Link>
            );
          })}
        </div>

        {/* CENTRE — logo image */}
        <NavLink to="/" data-testid="nav-logo" className="flex items-center">
          <img src="/brand/berides-logo.png" alt="beRides" className="h-8 w-auto brightness-0 invert" />
        </NavLink>

        {/* RIGHT — account actions */}
        <div className="flex items-center justify-end gap-5 text-white/90">
          <button data-testid="nav-search-btn" className="hover:text-white transition" aria-label="Search">
            <Search size={18} />
          </button>
          <button data-testid="nav-sell-btn" className="font-display text-[13px] tracking-[0.2em] uppercase hover:text-white transition">
            SELL
          </button>
          <button data-testid="nav-video-btn" className="hover:text-white transition" aria-label="Video">
            <Video size={18} />
          </button>
          <button data-testid="nav-cart-btn" className="hover:text-white transition relative" aria-label="Cart">
            <ShoppingCart size={18} />
            <span className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-[var(--accent)] text-white text-[9px] font-bold flex items-center justify-center">3</span>
          </button>
          <button data-testid="nav-notif-btn" className="hover:text-white transition" aria-label="Notifications">
            <Bell size={18} />
          </button>
          <button data-testid="nav-login-btn" className="bg-[var(--accent)] hover:bg-[#6f0c0c] text-white font-display font-semibold tracking-[0.2em] text-[11px] uppercase px-4 h-9 rounded transition">
            LOG IN
          </button>
        </div>
      </div>
    </nav>
  );
};

export default TopNav;
